import React, {
    useEffect,
    useMemo,
    useState
} from "react";

import api from "../../api/api";
import {
    useAcademicYear
} from "../../AcademicYearContext";

import Swal from "sweetalert2";

import {
    Button,
    Card,
    Col,
    Divider,
    Empty,
    Form,
    Input,
    InputNumber,
    Select,
    Space,
    Spin,
    Statistic,
    Tag,
    Typography,
    Upload,
    Collapse,
    Row
} from "antd";

import {
    DeleteOutlined,
    DownOutlined,
    EyeOutlined,
    FunctionOutlined,
    PaperClipOutlined,
    PictureOutlined,
    PlusOutlined,
    UpOutlined,
    UploadOutlined
} from "@ant-design/icons";
import StructuredContentEditor from "./structured-content/StructuredContentEditor";

const {
    Title,
    Text
} = Typography;

const {
    TextArea
} = Input;

const COLORS = {
    orange: "#f97316",
    darkOrange: "#ea580c",
    black: "#111111",
    camel: "#c19a6b",
    lightCamel: "#f5eadb",
    cream: "#fffaf3",
    white: "#ffffff",
    gray: "#f5f5f5",
    border: "#e5d4c0",
    red: "#dc2626",
    green: "#16a34a",
    blue: "#2563eb"
};

const QUESTION_TYPES = [
    {
        value: "fill_blank",
        label: "Fill in the Blanks"
    },
    {
        value: "multiple_choice",
        label: "Multiple Choice"
    },
    {
        value: "essay",
        label: "Essay"
    },
    {
        value: "paragraph",
        label: "Paragraph Writing"
    },
    {
        value: "short_answer",
        label: "Short Answer"
    },
    {
        value: "true_false",
        label: "True / False"
    },
    {
        value: "matching",
        label: "Matching"
    },
    {
        value: "drawing",
        label: "Drawing / Graph"
    },
    {
        value: "mixed",
        label: "Mixed Question"
    }
];

const toISO = (
    datetime
) => {
    if (!datetime) return "";

    const date = new Date(
        datetime
    );

    return Number.isNaN(
        date.getTime()
    )
        ? ""
        : date.toISOString();
};

const isValidHMS = (
    value
) => {
    if (!value) return false;

    const parts =
        value.split(":");

    if (
        parts.length !== 3
    ) {
        return false;
    }

    const [
        hours,
        minutes,
        seconds
    ] = parts.map(
        Number
    );

    return (
        Number.isInteger(
            hours
        ) &&
        Number.isInteger(
            minutes
        ) &&
        Number.isInteger(
            seconds
        ) &&
        hours >= 0 &&
        minutes >= 0 &&
        minutes <= 59 &&
        seconds >= 0 &&
        seconds <= 59
    );
};

const createEmptyQuestion = () => ({
    question_text: "",
    clarification: "",
    marks: 1,

    option_a: "",
    option_b: "",
    option_c: "",
    option_d: "",

    correct_answer: "",

    question_image: null,
    attachment: null,

    structured_payload: {
        blocks: []
    }
});

const buildSectionsForSubmit = (
    sections
) =>
    sections.map(
        (
            section
        ) => ({
            ...section,
            number_of_questions:
                section.questions?.length ||
                0
        })
    );

// const Test = () => {
const Test = ({
    editTest = null,
    onUpdated = null
}) => {
//     console.log(
//     "TEST COMPONENT OPENED",
//     editTest
// );
    const {
        selectedYear,
        loading:
            loadingAcademicYear
    } = useAcademicYear();
    const isEditMode = Boolean(editTest?.id);

    const [
        subjects,
        setSubjects
    ] = useState([]);

    const [
        gradeClasses,
        setGradeClasses
    ] = useState([]);

    const [
        periods,
        setPeriods
    ] = useState([]);

    const [
        teacherId,
        setTeacherId
    ] = useState(null);

    const [
        loadingMeta,
        setLoadingMeta
    ] = useState(false);

    const [
        metadataLoaded,
        setMetadataLoaded
    ] = useState(false);

    const [
        publishing,
        setPublishing
    ] = useState(false);

    const [
        formData,
        setFormData
    ] = useState({
        direction: "",
        grade_class: "",
        subject: "",
        period: "",
        start_time: "",
        end_time: "",
        duration: ""
    });

    const [
        sections,
        setSections
    ] = useState([]);

    const [
        expandedQuestions,
        setExpandedQuestions
    ] = useState({});

// Edit

const toDateTimeLocal = (value) => {
    if (!value) {
        return "";
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return "";
    }
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60000);
    return localDate.toISOString().slice(0, 16);
};

useEffect(() => {
    if (!editTest?.id) {
        return;
    }

// console.log(
//     "EDIT TEST KEYS:",
//     Object.keys(editTest)
// );


// console.log(
//     "EDIT TEST JSON:",
//     JSON.stringify(editTest, null, 2)
// );


    const mappedSections = (
        editTest.sections || []
    ).map(section => ({
        ...section,

        questions: (
            section.questions || []
        ).map(question => ({

            ...question,

            question_text:
                question.question_text ??
                question.text ??
                question.question ??
                question.question?.question_text ??
                "",


            clarification:
                question.clarification ??
                "",


            marks:
                question.marks ??
                1,


            option_a:
                question.option_a ??
                "",

            option_b:
                question.option_b ??
                "",

            option_c:
                question.option_c ??
                "",

            option_d:
                question.option_d ??
                "",


            correct_answer:
                question.correct_answer ??
                "",


            structured_payload:
                question.structured_payload ??
                question.structured_content ??
                {
                    blocks: []
                }

        }))
    }));


    // console.log(
    //     "MAPPED SECTIONS:",
    //     mappedSections
    // );


    setSections(
        mappedSections
    );


    const expanded = {};

    mappedSections.forEach(
        (
            section,
            sectionIndex
        ) => {

            (
                section.questions || []
            ).forEach(
                (
                    question,
                    questionIndex
                ) => {

                    expanded[
                        `${sectionIndex}-${questionIndex}`
                    ] = true;

                }
            );

        }
    );


    setExpandedQuestions(
        expanded
    );


    setFormData({

        direction:
            editTest.direction ??
            "",


        grade_class:
            editTest.grade_class?.id ??
            editTest.grade_class ??
            "",


        subject:
            editTest.subject?.id ??
            editTest.subject ??
            "",


        period:
            editTest.period?.id ??
            editTest.period ??
            "",


        start_time:
            toDateTimeLocal(
                editTest.start_time
            ),


        end_time:
            toDateTimeLocal(
                editTest.end_time
            ),


        duration:
            editTest.duration ??
            ""

    });


}, [editTest]);

// Edit Close

    useEffect(() => {
if (
    loadingAcademicYear ||
    !selectedYear?.id
) {
    return (
        <div
            style={{
                minHeight: "60vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: 16
            }}
        >
            <Spin size="large" />

            <Text type="secondary">
                Loading...
            </Text>
        </div>
    );
}

        let cancelled = false;

        const loadMetadata =
            async () => {
                setLoadingMeta(
                    true
                );

                setMetadataLoaded(
                    false
                );

                try {
                    const [
                        teacherResponse,
                        periodsResponse
                    ] =
                        await Promise.all(
                            [
                                api.get(
                                    "/api/users/teacher-subjects/"
                                ),
                                api.get(
                                    "/api/users/periods/"
                                )
                            ]
                        );

                    if (
                        cancelled
                    ) {
                        return;
                    }

                    setSubjects(
                        teacherResponse
                            .data
                            ?.subjects ||
                            []
                    );

                    setGradeClasses(
                        teacherResponse
                            .data
                            ?.grade_classes ||
                            []
                    );

                    setTeacherId(
                        teacherResponse
                            .data
                            ?.teacher_id ??
                            null
                    );

                    setPeriods(
                        Array.isArray(
                            periodsResponse.data
                        )
                            ? periodsResponse.data
                            : periodsResponse
                                  .data
                                  ?.results ||
                              []
                    );

                    setMetadataLoaded(
                        true
                    );
                } catch (
                    error
                ) {
                    if (
                        cancelled
                    ) {
                        return;
                    }

                    console.error(
                        "Metadata loading error:",
                        error
                    );

                    setSubjects(
                        []
                    );

                    setGradeClasses(
                        []
                    );

                    setPeriods(
                        []
                    );

                    setTeacherId(
                        null
                    );

                    Swal.fire(
                        "Error",
                        "Failed to load teacher data or periods.",
                        "error"
                    );
                } finally {
                    if (
                        !cancelled
                    ) {
                        setLoadingMeta(
                            false
                        );
                    }
                }
            };

        loadMetadata();

        return () => {
            cancelled = true;
        };
    }, [
        loadingAcademicYear,
        selectedYear?.id
    ]);

    useEffect(() => {
        if (
            !formData.start_time ||
            !formData.end_time
        ) {
            return;
        }

        const start =
            new Date(
                formData.start_time
            );

        const end =
            new Date(
                formData.end_time
            );

        if (
            Number.isNaN(
                start.getTime()
            ) ||
            Number.isNaN(
                end.getTime()
            )
        ) {
            return;
        }

        if (
            end > start
        ) {
            const totalSeconds =
                Math.floor(
                    (
                        end - start
                    ) / 1000
                );

            const hours =
                Math.floor(
                    totalSeconds /
                        3600
                );

            const minutes =
                Math.floor(
                    (
                        totalSeconds %
                        3600
                    ) / 60
                );

            const seconds =
                totalSeconds %
                60;

            const formatted =
                [
                    hours,
                    minutes,
                    seconds
                ]
                    .map(
                        (
                            number
                        ) =>
                            number
                                .toString()
                                .padStart(
                                    2,
                                    "0"
                                )
                    )
                    .join(":");

            if (
                formatted !==
                formData.duration
            ) {
                setFormData(
                    (
                        previous
                    ) => ({
                        ...previous,
                        duration:
                            formatted
                    })
                );
            }
        } else if (
            formData.duration
        ) {
            setFormData(
                (
                    previous
                ) => ({
                    ...previous,
                    duration: ""
                })
            );
        }
    }, [
        formData.start_time,
        formData.end_time
    ]);

    const handleChange = (
        field,
        value
    ) => {
        setFormData(
            (
                previous
            ) => ({
                ...previous,
                [field]: value
            })
        );
    };

    const addSection = () => {
        setSections(
            (
                previous
            ) => [
                ...previous,
                {
                    question_type:
                        "",
                    allocated_marks:
                        "",
                    number_of_questions:
                        0,
                    questions: []
                }
            ]
        );
    };

    const updateSection = (
        sectionIndex,
        field,
        value
    ) => {
        setSections(
            (
                previous
            ) => {
                const copy = [
                    ...previous
                ];

                if (
                    !copy[
                        sectionIndex
                    ]
                ) {
                    return previous;
                }

                copy[
                    sectionIndex
                ] = {
                    ...copy[
                        sectionIndex
                    ],
                    [field]: value
                };

                return copy;
            }
        );
    };

    const deleteSection = (
        sectionIndex
    ) => {
        setSections(
            (
                previous
            ) =>
                previous.filter(
                    (
                        _,
                        index
                    ) =>
                        index !==
                        sectionIndex
                )
        );
    };

    const addQuestion = (
        sectionIndex
    ) => {
        setSections(
            (
                previous
            ) => {
                const copy = [
                    ...previous
                ];

                if (
                    !copy[
                        sectionIndex
                    ]
                ) {
                    return previous;
                }

                const section = {
                    ...copy[
                        sectionIndex
                    ]
                };

                section.questions =
                    [
                        ...(
                            section.questions ||
                            []
                        ),
                        createEmptyQuestion()
                    ];

                copy[
                    sectionIndex
                ] = section;

                return copy;
            }
        );
    };

    const updateQuestion = (
        sectionIndex,
        questionIndex,
        field,
        value
    ) => {
        setSections(
            (
                previous
            ) => {
                const copy = [
                    ...previous
                ];

                if (
                    !copy[
                        sectionIndex
                    ]
                ) {
                    return previous;
                }

                const section = {
                    ...copy[
                        sectionIndex
                    ]
                };

                const questions =
                    [
                        ...(
                            section.questions ||
                            []
                        )
                    ];

                if (
                    !questions[
                        questionIndex
                    ]
                ) {
                    return previous;
                }

                questions[
                    questionIndex
                ] = {
                    ...questions[
                        questionIndex
                    ],
                    [field]: value
                };

                section.questions =
                    questions;

                copy[
                    sectionIndex
                ] = section;

                return copy;
            }
        );
    };

    const deleteQuestion = (
        sectionIndex,
        questionIndex
    ) => {
        setSections(
            (
                previous
            ) => {
                const copy = [
                    ...previous
                ];

                if (
                    !copy[
                        sectionIndex
                    ]
                ) {
                    return previous;
                }

                const section = {
                    ...copy[
                        sectionIndex
                    ]
                };

                const questions =
                    [
                        ...(
                            section.questions ||
                            []
                        )
                    ];

                questions.splice(
                    questionIndex,
                    1
                );

                section.questions =
                    questions;

                copy[
                    sectionIndex
                ] = section;

                return copy;
            }
        );
    };

    const toggleQuestion = (
        sectionIndex,
        questionIndex
    ) => {
        const key =
            `${sectionIndex}-${questionIndex}`;

        setExpandedQuestions(
            (
                previous
            ) => ({
                ...previous,
                [key]:
                    !previous[
                        key
                    ]
            })
        );
    };

    const totalMarks = useMemo(
        () =>
            sections.reduce(
                (
                    total,
                    section
                ) =>
                    total +
                    parseInt(
                        section.allocated_marks ||
                            0,
                        10
                    ),
                0
            ),
        [
            sections
        ]
    );

    const publishDisabled =
        useMemo(
            () => {
                if (
                    !teacherId ||
                    !selectedYear?.id
                ) {
                    return true;
                }

                if (
                    !formData.direction.trim() ||
                    !formData.grade_class ||
                    !formData.subject ||
                    !formData.period ||
                    !formData.start_time ||
                    !formData.end_time ||
                    !isValidHMS(
                        formData.duration
                    ) ||
                    !sections.length
                ) {
                    return true;
                }

                for (
                    const section of sections
                ) {
                    if (
                        !section.question_type ||
                        !section.allocated_marks ||
                        !section.questions
                            ?.length
                    ) {
                        return true;
                    }
                }

                for (
                    const section of sections
                ) {
                    for (
                        const question of section.questions
                    ) {
                        if (
                            !question.question_text?.trim()
                        ) {
                            return true;
                        }
                    }
                }

                return false;
            },
            [
                teacherId,
                selectedYear?.id,
                formData,
                sections
            ]
        );

    const resetForm = () => {
        setFormData({
            direction: "",
            grade_class: "",
            subject: "",
            period: "",
            start_time: "",
            end_time: "",
            duration: ""
        });

        setSections(
            []
        );

        setExpandedQuestions(
            {}
        );
    };

useEffect(() => {

    // console.log(
    //     "SECTIONS STATE:",
    //     sections
    // );

    // console.log(
    //     "QUESTION TEXT:",
    //     sections?.[0]?.questions?.[0]?.question_text
    // );

}, [sections]);

const handlePublish = async () => {
    if (publishDisabled) {
        Swal.fire("Missing Data", "Please fill all required fields before publishing.", "warning");
        return;
    }
    setPublishing(true);
    try {
        const cleanedSections = buildSectionsForSubmit(sections);
        const hasFiles = cleanedSections.some((section) => (section.questions || []).some((question) => question.question_image || question.attachment));
        const isEditMode = Boolean(editTest?.id);
        // console.log(
        //     "TEST COMPONENT EDIT DATA",
        //     editTest
        // );
        let response;
        if (hasFiles) {
            const formDataToSend = new FormData();
            formDataToSend.append("direction", formData.direction);
            formDataToSend.append("grade_class", formData.grade_class);
            formDataToSend.append("subject", formData.subject);
            formDataToSend.append("period", formData.period);
            formDataToSend.append("start_time", toISO(formData.start_time));
            formDataToSend.append("end_time", toISO(formData.end_time));
            formDataToSend.append("duration", formData.duration);
            formDataToSend.append("academic_year", selectedYear.id);
            formDataToSend.append("sections", JSON.stringify(cleanedSections));
            cleanedSections.forEach((section, sectionIndex) => {
                (section.questions || []).forEach((question, questionIndex) => {
                    if (question.question_image) {
                        formDataToSend.append(`question_image_${sectionIndex}_${questionIndex}`, question.question_image);
                    }
                    if (question.attachment) {
                        formDataToSend.append(`attachment_${sectionIndex}_${questionIndex}`, question.attachment);
                    }
                });
            });
            response = isEditMode
                ? await api.put(`/api/periodic-tests/${editTest.id}/`, formDataToSend, {
                    timeout: 120000,
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                : await api.post("/api/periodic-tests/", formDataToSend, {
                    timeout: 120000,
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
        } else {
const payload = {
    ...formData,
    academic_year: selectedYear.id,
    start_time: toISO(formData.start_time),
    end_time: toISO(formData.end_time),
    sections: cleanedSections
};
response = isEditMode
    ? await api.put(`/api/periodic-tests/${editTest.id}/`, payload)
    : await api.post("/api/periodic-tests/", payload);
}


Swal.fire(
    "Success",
    isEditMode ? "Test updated successfully!" : "Test created successfully!",
    "success"
);
        if (isEditMode) {
            if (onUpdated) {
                onUpdated(response.data);
            }
        } else {
            resetForm();
        }
    } catch (error) {
        console.error("Publish error:", error);
        if (error.response) {
            Swal.fire({
                title: "Error",
                html: `<b>Status:</b> ${error.response.status}<br/><b>Response:</b><pre style="text-align:left;white-space:pre-wrap;">${typeof error.response.data === "string" ? error.response.data : JSON.stringify(error.response.data, null, 2)}</pre>`,
                icon: "error",
                width: 700
            });
        } else if (error.request) {
            Swal.fire("Error", "No response from server.", "error");
        } else {
            Swal.fire("Error", error.message, "error");
        }
    } finally {
        setPublishing(false);
    }
};

    if (loadingAcademicYear ||
        !selectedYear?.id ||
        !metadataLoaded
    ) {
        return (
            <div
                style={{
                    minHeight:
                        "60vh",
                    display:
                        "flex",
                    justifyContent:
                        "center",
                    alignItems:
                        "center",
                    flexDirection:
                        "column",
                    gap: 16
                }}
            >
                <Spin
                    size="large"
                />

                <Text type="secondary">
                    {loadingAcademicYear
                        ? "Loading academic year..."
                        : loadingMeta
                        ? "Loading teacher data..."
                        : "Preparing test form..."}
                </Text>
            </div>
        );
    }

    return (
        <>
            <style>
                {`
                    .test-form .ant-form-item {
                        margin-bottom: 22px;
                    }

                    .test-form .ant-form-item-label {
                        padding-bottom: 8px;
                    }

                    .test-form .ant-form-item-label > label {
                        font-size: 15px;
                        font-weight: 700;
                        color: ${COLORS.black};
                    }

                    .test-form .ant-input,
                    .test-form .ant-input-number,
                    .test-form .ant-select-selector {
                        min-height: 48px !important;
                        border-radius: 10px !important;
                        font-size: 15px;
                    }

                    .test-form .ant-input-number {
                        width: 100%;
                    }

                    .test-form .ant-input-number-input {
                        height: 46px;
                        font-size: 15px;
                    }

                    .test-form .ant-select-selection-item,
                    .test-form .ant-select-selection-placeholder {
                        line-height: 46px !important;
                        font-size: 15px;
                    }

                    .test-form textarea.ant-input {
                        min-height: 120px;
                        padding: 14px;
                        font-size: 15px;
                        line-height: 1.6;
                    }

                    @media (max-width: 767px) {
                        .test-form .ant-form-item-label {
                            width: 100%;
                            text-align: center;
                            padding-bottom: 10px;
                        }

                        .test-form .ant-form-item-label > label {
                            width: 100%;
                            justify-content: center;
                            text-align: center;
                            font-size: 16px;
                        }

                        .test-form .ant-input,
                        .test-form .ant-input-number,
                        .test-form .ant-select,
                        .test-form .ant-picker,
                        .test-form .ant-input-affix-wrapper {
                            width: 96% !important;
                            margin: 0 auto;
                        }

                        .test-form textarea.ant-input {
                            width: 96% !important;
                            margin: 0 auto;
                            min-height: 140px;
                            font-size: 16px;
                        }

                        .delete-label {
                            display: none;
                        }
                    }

                    @media (min-width: 768px) {
                        .test-form .ant-input,
                        .test-form .ant-input-number,
                        .test-form .ant-select {
                            width: 100%;
                        }
                    }
                `}
            </style>

<div
style={{
    minHeight: "100%",
    width: "100%",
    padding: "clamp(12px, 3vw, 32px)",
    background: COLORS.cream,
    overflow: "visible"
}}
>
                <div
                    style={{
                        maxWidth:
                            1400,
                        margin:
                            "0 auto"
                    }}
                >
                    <Card
                        style={{
                            marginBottom:
                                24,
                            border:
                                "none",
                            borderRadius:
                                16,
                            background:
                                COLORS.black,
                            boxShadow:
                                "0 8px 24px rgba(0,0,0,0.12)"
                        }}
                    >
                        <Row
                            justify="space-between"
                            align="middle"
                            gutter={[
                                16,
                                16
                            ]}
                        >
                            <Col
                                xs={24}
                                md={16}
                            >
                                <Title
                                    level={
                                        2
                                    }
                                    style={{
                                        color:
                                            COLORS.white,
                                        margin:
                                            0
                                    }}
                                >
                                    Create Test
                                </Title>

                                <Text
                                    style={{
                                        color:
                                            COLORS.camel
                                    }}
                                >
                                    Build a complete test with sections, questions, mathematical content, geometric shapes, graphs, images, and attachments.
                                </Text>
                            </Col>

                            <Col
                                xs={24}
                                md={8}
                            >
                                <div
                                    style={{
                                        background:
                                            COLORS.orange,
                                        borderRadius:
                                            12,
                                        padding:
                                            16,
                                        textAlign:
                                            "center"
                                    }}
                                >
                                    <Text
                                        strong
                                        style={{
                                            color:
                                                COLORS.white
                                        }}
                                    >
                                        Academic Year
                                    </Text>

                                    <div
                                        style={{
                                            color:
                                                COLORS.white,
                                            fontSize:
                                                18,
                                            fontWeight:
                                                700,
                                            marginTop:
                                                4
                                        }}
                                    >
                                        {
                                            selectedYear.name
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card>

                    <Card
                        title="Test Information"
                        style={{
                            marginBottom:
                                24,
                            borderRadius:
                                16,
                            borderColor:
                                COLORS.border
                        }}
                    >
                        <Form
                            layout="vertical"
                            className="test-form"
                        >
                            <Row
                                gutter={[
                                    24,
                                    20
                                ]}
                            >
                                <Col
                                    xs={24}
                                >
                                    <Form.Item
                                        label="Direction"
                                        required
                                    >
                                        <TextArea
                                            rows={
                                                3
                                            }
                                            placeholder="Enter the general direction or instruction for this test"
                                            value={
                                                formData.direction
                                            }
                                            onChange={(
                                                event
                                            ) =>
                                                handleChange(
                                                    "direction",
                                                    event
                                                        .target
                                                        .value
                                                )
                                            }
                                        />
                                    </Form.Item>
                                </Col>

                                <Col
                                    xs={24}
                                    md={8}
                                >
                                    <Form.Item
                                        label="Grade Class"
                                        required
                                    >
                                 <Select
    getPopupContainer={(triggerNode) =>
        triggerNode.parentNode
    }
    placeholder="Select grade class"
    value={
        formData.grade_class ||
        undefined
    }
    onChange={(value) =>
        handleChange(
            "grade_class",
            value
        )
    }
    options={gradeClasses.map(
        (gradeClass) => ({
            value: gradeClass.id,
            label: gradeClass.name
        })
    )}
/>
                                    </Form.Item>
                                </Col>

                                <Col
                                    xs={24}
                                    md={8}
                                >
                                    <Form.Item
                                        label="Subject"
                                        required
                                    >
                                        <Select
    getPopupContainer={(triggerNode) =>
        triggerNode.parentNode
    }
                                            placeholder="Select subject"
                                            value={
                                                formData.subject ||
                                                undefined
                                            }
                                            onChange={(
                                                value
                                            ) =>
                                                handleChange(
                                                    "subject",
                                                    value
                                                )
                                            }
                                            options={subjects.map(
                                                (
                                                    subject
                                                ) => ({
                                                    value:
                                                        subject.id,
                                                    label:
                                                        subject.name
                                                })
                                            )}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col
                                    xs={24}
                                    md={8}
                                >
                                    <Form.Item
                                        label="Period"
                                        required
                                    >
                                        <Select
                                            getPopupContainer={(triggerNode) =>
                                                triggerNode.parentNode
                                            }
                                            placeholder="Select period"
                                            value={
                                                formData.period ||
                                                undefined
                                            }
                                            onChange={(
                                                value
                                            ) =>
                                                handleChange(
                                                    "period",
                                                    value
                                                )
                                            }
                                            options={periods.map(
                                                (
                                                    period
                                                ) => ({
                                                    value:
                                                        period.id,
                                                    label:
                                                        period.name
                                                })
                                            )}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col
                                    xs={24}
                                    md={8}
                                >
                                    <Form.Item
                                        label="Start Time"
                                        required
                                    >
                                        <Input
                                            type="datetime-local"
                                            value={
                                                formData.start_time
                                            }
                                            onChange={(
                                                event
                                            ) =>
                                                handleChange(
                                                    "start_time",
                                                    event
                                                        .target
                                                        .value
                                                )
                                            }
                                        />
                                    </Form.Item>
                                </Col>

                                <Col
                                    xs={24}
                                    md={8}
                                >
                                    <Form.Item
                                        label="End Time"
                                        required
                                    >
                                        <Input
                                            type="datetime-local"
                                            value={
                                                formData.end_time
                                            }
                                            onChange={(
                                                event
                                            ) =>
                                                handleChange(
                                                    "end_time",
                                                    event
                                                        .target
                                                        .value
                                                )
                                            }
                                        />
                                    </Form.Item>
                                </Col>

                                <Col
                                    xs={24}
                                    md={8}
                                >
                                    <Form.Item
                                        label="Duration (HH:MM:SS)"
                                        required
                                    >
                                        <Input
                                            placeholder="00:45:00"
                                            value={
                                                formData.duration
                                            }
                                            onChange={(
                                                event
                                            ) =>
                                                handleChange(
                                                    "duration",
                                                    event
                                                        .target
                                                        .value
                                                )
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>

                    <Card
                        style={{
                            marginBottom:
                                24,
                            borderRadius:
                                16,
                            borderColor:
                                COLORS.border
                        }}
                    >
                        <Row
                            justify="space-between"
                            align="middle"
                            gutter={[
                                16,
                                16
                            ]}
                        >
                            <Col
                                xs={24}
                                md={16}
                            >
                                <Title
                                    level={
                                        3
                                    }
                                    style={{
                                        margin:
                                            0,
                                        color:
                                            COLORS.black
                                    }}
                                >
                                    Sections & Questions
                                </Title>

                                <Text type="secondary">
                                    Add sections and create questions for your test.
                                </Text>
                            </Col>

                            <Col
                                xs={24}
                                md={8}
                            >
                                <Button
                                    type="primary"
                                    block
                                    icon={
                                        <PlusOutlined />
                                    }
                                    onClick={
                                        addSection
                                    }
                                    style={{
                                        background:
                                            COLORS.orange,
                                        borderColor:
                                            COLORS.orange,
                                        height:
                                            48,
                                        fontWeight:
                                            700
                                    }}
                                >
                                    Add Section
                                </Button>
                            </Col>
                        </Row>

                        <Divider />

                        <Statistic
                            title="Total Marks"
                            value={
                                totalMarks
                            }
                            valueStyle={{
                                color:
                                    COLORS.orange,
                                fontWeight:
                                    700
                            }}
                        />
                    </Card>

                    {
                        sections.length ===
                            0 && (
                            <Card
                                style={{
                                    borderRadius:
                                        16,
                                    marginBottom:
                                        24
                                }}
                            >
                                <Empty description="No sections added yet">
                                    <Button
                                        type="primary"
                                        icon={
                                            <PlusOutlined />
                                        }
                                        onClick={
                                            addSection
                                        }
                                        style={{
                                            background:
                                                COLORS.orange,
                                            borderColor:
                                                COLORS.orange
                                        }}
                                    >
                                        Add Your First Section
                                    </Button>
                                </Empty>
                            </Card>
                        )
                    }

                    {
                        sections.map(
                            (
                                section,
                                sectionIndex
                            ) => (
                                <Card
                                    key={
                                        sectionIndex
                                    }
                                    style={{
                                        marginBottom:
                                            24,
                                        borderRadius:
                                            16,
                                        borderColor:
                                            COLORS.border
                                    }}
                                    title={
                                        <Space>
                                            <Tag
                                                color={
                                                    COLORS.orange
                                                }
                                            >
                                                SECTION{" "}
                                                {
                                                    sectionIndex +
                                                    1
                                                }
                                            </Tag>

                                            <Text strong>
                                                {
                                                    section.question_type
                                                        ? QUESTION_TYPES.find(
                                                              (
                                                                  item
                                                              ) =>
                                                                  item.value ===
                                                                  section.question_type
                                                          )
                                                              ?.label
                                                        : "New Section"
                                                }
                                            </Text>
                                        </Space>
                                    }
                                    extra={
                                        <Button
                                            danger
                                            type="text"
                                            icon={
                                                <DeleteOutlined />
                                            }
                                            onClick={() =>
                                                deleteSection(
                                                    sectionIndex
                                                )
                                            }
                                        >
                                            <span className="delete-label">
                                                Delete
                                            </span>
                                        </Button>
                                    }
                                >
                                    <Form
                                        layout="vertical"
                                        className="test-form"
                                    >
                                        <Row
                                            gutter={[
                                                24,
                                                20
                                            ]}
                                        >
                                            <Col
                                                xs={24}
                                                md={12}
                                            >
                                                <Form.Item
                                                    label="Question Type"
                                                    required
                                                >
                                                   <Select
                                                        getPopupContainer={(triggerNode) =>
                                                            triggerNode.parentNode
                                                        }
                                                        placeholder="Select question type"
                                                    
                                                        value={
                                                            section.question_type ||
                                                            undefined
                                                        }
                                                        onChange={(
                                                            value
                                                        ) =>
                                                            updateSection(
                                                                sectionIndex,
                                                                "question_type",
                                                                value
                                                            )
                                                        }
                                                        options={
                                                            QUESTION_TYPES
                                                        }
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col
                                                xs={24}
                                                md={6}
                                            >
                                                <Form.Item
                                                    label="Allocated Marks"
                                                    required
                                                >
                                                    <InputNumber
                                                        min={
                                                            1
                                                        }
                                                        value={
                                                            section.allocated_marks ||
                                                            undefined
                                                        }
                                                        onChange={(
                                                            value
                                                        ) =>
                                                            updateSection(
                                                                sectionIndex,
                                                                "allocated_marks",
                                                                value
                                                            )
                                                        }
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col
                                                xs={24}
                                                md={6}
                                            >
                                                <Form.Item label="Number of Questions">
                                                    <InputNumber
                                                        disabled
                                                        value={
                                                            section.questions
                                                                ?.length ||
                                                            0
                                                        }
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Form>

                                    <Divider />

                                    <Button
                                        icon={
                                            <PlusOutlined />
                                        }
                                        onClick={() =>
                                            addQuestion(
                                                sectionIndex
                                            )
                                        }
                                    >
                                        Add Question
                                    </Button>

                                    {
                                        (
                                            section.questions ||
                                            []
                                        ).map(
                                            (
                                                question,
                                                questionIndex
                                            ) => {
                                                const questionKey =
                                                    `${sectionIndex}-${questionIndex}`;

                                                const isExpanded =
                                                    expandedQuestions[questionKey] ?? true;

                                                const hasStructuredContent =
                                                    question
                                                        .structured_payload
                                                        ?.blocks
                                                        ?.length >
                                                    0;

                                                return (
                                                    <Card
                                                        key={
                                                            questionIndex
                                                        }
                                                        size="small"
                                                            style={{
                                                            marginTop:16,
                                                            borderColor: COLORS.border,
                                                            background: COLORS.cream,
                                                            overflow:"visible"
                                                        }}
                                                        title={
                                                            <Space wrap>
                                                                <Tag
                                                                    color={
                                                                        COLORS.black
                                                                    }
                                                                >
                                                                    Question{" "}
                                                                    {
                                                                        questionIndex +
                                                                        1
                                                                    }
                                                                </Tag>

                                                                {
                                                                    hasStructuredContent && (
                                                                        <Tag
                                                                            icon={
                                                                                <FunctionOutlined />
                                                                            }
                                                                            color={
                                                                                COLORS.camel
                                                                            }
                                                                        >
                                                                            Structured Content
                                                                        </Tag>
                                                                    )
                                                                }
                                                            </Space>
                                                        }
                                                        extra={
                                                            <Space>
                                                                <Button
                                                                    type="text"
                                                                    icon={
                                                                        isExpanded ? (
                                                                            <UpOutlined />
                                                                        ) : (
                                                                            <DownOutlined />
                                                                        )
                                                                    }
                                                                    onClick={() =>
                                                                        toggleQuestion(
                                                                            sectionIndex,
                                                                            questionIndex
                                                                        )
                                                                    }
                                                                />

                                                                <Button
                                                                    danger
                                                                    type="text"
                                                                    icon={
                                                                        <DeleteOutlined />
                                                                    }
                                                                    onClick={() =>
                                                                        deleteQuestion(
                                                                            sectionIndex,
                                                                            questionIndex
                                                                        )
                                                                    }
                                                                />
                                                            </Space>
                                                        }
                                                    >
                                                        <Form
                                                            layout="vertical"
                                                            className="test-form"
                                                        >
                                                            <Form.Item
                                                                label="Question Text"
                                                                required
                                                            >
                                                        <TextArea
                                                            rows={5}
                                                            placeholder="Example: Calculate the area of the triangle below."
                                                            value={question.question_text || ""}
                                                            onChange={(event) =>
                                                                updateQuestion(
                                                                    sectionIndex,
                                                                    questionIndex,
                                                                    "question_text",
                                                                    event.target.value
                                                                )
                                                            }
                                                        />
                                                            </Form.Item>

                                                            <Form.Item label="Clarification / Instruction">
                                                                <TextArea
                                                                    rows={
                                                                        3
                                                                    }
                                                                    placeholder="Optional additional instruction for students."
                                                                    value={
                                                                        question.clarification
                                                                    }
                                                                    onChange={(
                                                                        event
                                                                    ) =>
                                                                        updateQuestion(
                                                                            sectionIndex,
                                                                            questionIndex,
                                                                            "clarification",
                                                                            event
                                                                                .target
                                                                                .value
                                                                        )
                                                                    }
                                                                />
                                                            </Form.Item>
                                                        </Form>

                                                        <Collapse
                                                            activeKey={
                                                                isExpanded
                                                                    ? [
                                                                          "editor"
                                                                      ]
                                                                    : []
                                                            }
                                                            onChange={(
                                                                keys
                                                            ) =>
                                                                setExpandedQuestions(
                                                                    (
                                                                        previous
                                                                    ) => ({
                                                                        ...previous,
                                                                        [questionKey]:
                                                                            keys.includes(
                                                                                "editor"
                                                                            )
                                                                    })
                                                                )
                                                            }
                                                        >
                                                            <Collapse.Panel
                                                                key="editor"
                                                                header="Advanced Editor & Preview"
                                                            >
                                                                <StructuredContentEditor
                                                                    question={
                                                                        question
                                                                    }
                                                                    updateQuestion={(
                                                                        field,
                                                                        value
                                                                    ) =>
                                                                        updateQuestion(
                                                                            sectionIndex,
                                                                            questionIndex,
                                                                            field,
                                                                            value
                                                                        )
                                                                    }
                                                                />
                                                                <div
                                                                    style={{
                                                                        padding: 20,
                                                                        background: "#f6f6f6",
                                                                        borderRadius: 8
                                                                    }}
                                                                >
                                                                    Editor Disabled
                                                                </div>
                                                                    </Collapse.Panel>
                                                        </Collapse>

                                                        {
                                                            section.question_type ===
                                                                "multiple_choice" && (
                                                                <Card
                                                                    size="small"
                                                                    title="Multiple Choice Options"
                                                                    style={{
                                                                        marginTop:
                                                                            16,
                                                                        borderColor:
                                                                            COLORS.border
                                                                    }}
                                                                >
                                                                    <Form
                                                                        layout="vertical"
                                                                        className="test-form"
                                                                    >
                                                                        <Row
                                                                            gutter={[
                                                                                24,
                                                                                20
                                                                            ]}
                                                                        >
                                                                            {[
                                                                                "a",
                                                                                "b",
                                                                                "c",
                                                                                "d"
                                                                            ].map(
                                                                                (
                                                                                    option
                                                                                ) => (
                                                                                    <Col
                                                                                        xs={
                                                                                            24
                                                                                        }
                                                                                        md={
                                                                                            12
                                                                                        }
                                                                                        key={
                                                                                            option
                                                                                        }
                                                                                    >
                                                                                        <Form.Item
                                                                                            label={`Option ${option.toUpperCase()}`}
                                                                                        >
                                                                                            <Input
                                                                                                value={
                                                                                                    question[
                                                                                                        `option_${option}`
                                                                                                    ]
                                                                                                }
                                                                                                onChange={(
                                                                                                    event
                                                                                                ) =>
                                                                                                    updateQuestion(
                                                                                                        sectionIndex,
                                                                                                        questionIndex,
                                                                                                        `option_${option}`,
                                                                                                        event
                                                                                                            .target
                                                                                                            .value
                                                                                                    )
                                                                                                }
                                                                                            />
                                                                                        </Form.Item>
                                                                                    </Col>
                                                                                )
                                                                            )}

                                                                            <Col
                                                                                xs={
                                                                                    24
                                                                                }
                                                                            >
                                                                                <Form.Item label="Correct Answer">
                                                                                    <Input
                                                                                        value={
                                                                                            question.correct_answer
                                                                                        }
                                                                                        onChange={(
                                                                                            event
                                                                                        ) =>
                                                                                            updateQuestion(
                                                                                                sectionIndex,
                                                                                                questionIndex,
                                                                                                "correct_answer",
                                                                                                event
                                                                                                    .target
                                                                                                    .value
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                </Form.Item>
                                                                            </Col>
                                                                        </Row>
                                                                    </Form>
                                                                </Card>
                                                            )
                                                        }

                                                        <Form
                                                            layout="vertical"
                                                            className="test-form"
                                                        >
                                                            <Row
                                                                gutter={[
                                                                    24,
                                                                    20
                                                                ]}
                                                                style={{
                                                                    marginTop:
                                                                        16
                                                                }}
                                                            >
                                                                <Col
                                                                    xs={
                                                                        24
                                                                    }
                                                                    sm={
                                                                        8
                                                                    }
                                                                >
                                                                    <Form.Item label="Marks">
                                                                        <InputNumber
                                                                            min={
                                                                                1
                                                                            }
                                                                            value={
                                                                                question.marks
                                                                            }
                                                                            onChange={(
                                                                                value
                                                                            ) =>
                                                                                updateQuestion(
                                                                                    sectionIndex,
                                                                                    questionIndex,
                                                                                    "marks",
                                                                                    value
                                                                                )
                                                                            }
                                                                        />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col
                                                                    xs={
                                                                        24
                                                                    }
                                                                    sm={
                                                                        16
                                                                    }
                                                                >
                                                                    <Space
                                                                        wrap
                                                                        style={{
                                                                            width:
                                                                                "100%",
                                                                            marginTop:
                                                                                30
                                                                        }}
                                                                    >
                                                                        <Upload
                                                                            beforeUpload={(
                                                                                file
                                                                            ) => {
                                                                                updateQuestion(
                                                                                    sectionIndex,
                                                                                    questionIndex,
                                                                                    "question_image",
                                                                                    file
                                                                                );

                                                                                return false;
                                                                            }}
                                                                            showUploadList={
                                                                                false
                                                                            }
                                                                            accept="image/*"
                                                                        >
                                                                            <Button
                                                                                icon={
                                                                                    <PictureOutlined />
                                                                                }
                                                                                size="large"
                                                                            >
                                                                                Upload Image
                                                                            </Button>
                                                                        </Upload>

                                                                        <Upload
                                                                            beforeUpload={(
                                                                                file
                                                                            ) => {
                                                                                updateQuestion(
                                                                                    sectionIndex,
                                                                                    questionIndex,
                                                                                    "attachment",
                                                                                    file
                                                                                );

                                                                                return false;
                                                                            }}
                                                                            showUploadList={
                                                                                false
                                                                            }
                                                                        >
                                                                            <Button
                                                                                icon={
                                                                                    <PaperClipOutlined />
                                                                                }
                                                                                size="large"
                                                                            >
                                                                                Upload Attachment
                                                                            </Button>
                                                                        </Upload>

                                                                        <Button
                                                                            icon={
                                                                                <EyeOutlined />
                                                                            }
                                                                            size="large"
                                                                            onClick={() =>
                                                                                setExpandedQuestions(
                                                                                    (
                                                                                        previous
                                                                                    ) => ({
                                                                                        ...previous,
                                                                                        [questionKey]:
                                                                                            true
                                                                                    })
                                                                                )
                                                                            }
                                                                        >
                                                                            Preview
                                                                        </Button>
                                                                    </Space>
                                                                </Col>
                                                            </Row>
                                                        </Form>

                                                        {
                                                            question.question_image && (
                                                                <div
                                                                    style={{
                                                                        marginTop:
                                                                            12,
                                                                        padding:
                                                                            10,
                                                                        borderRadius:
                                                                            8,
                                                                        background:
                                                                            "#f0fdf4",
                                                                        color:
                                                                            COLORS.green
                                                                    }}
                                                                >
                                                                    Image:{" "}
                                                                    {
                                                                        question
                                                                            .question_image
                                                                            .name
                                                                    }
                                                                </div>
                                                            )
                                                        }

                                                        {
                                                            question.attachment && (
                                                                <div
                                                                    style={{
                                                                        marginTop:
                                                                            12,
                                                                        padding:
                                                                            10,
                                                                        borderRadius:
                                                                            8,
                                                                        background:
                                                                            "#eff6ff",
                                                                        color:
                                                                            COLORS.blue
                                                                    }}
                                                                >
                                                                    Attachment:{" "}
                                                                    {
                                                                        question
                                                                            .attachment
                                                                            .name
                                                                    }
                                                                </div>
                                                            )
                                                        }
                                                    </Card>
                                                );
                                            }
                                        )
                                    }
                                </Card>
                            )
                        )
                    }

                    <Card
                        style={{
                            borderRadius:
                                16,
                            borderColor:
                                COLORS.border
                        }}
                    >
                        <Row
                            justify="space-between"
                            align="middle"
                            gutter={[
                                16,
                                16
                            ]}
                        >
                            <Col
                                xs={24}
                                md={12}
                            >
                                <Text strong>
                                    Total Marks:{" "}
                                    <span
                                        style={{
                                            color:
                                                COLORS.orange,
                                            fontSize:
                                                20
                                        }}
                                    >
                                        {
                                            totalMarks
                                        }
                                    </span>
                                </Text>
                            </Col>

                            <Col
                                xs={24}
                                md={12}
                            >
                                <Button
                                    type="primary"
                                    size="large"
                                    block
                                    loading={
                                        publishing
                                    }
                                    disabled={
                                        publishing ||
                                        publishDisabled
                                    }
                                    icon={
                                        <UploadOutlined />
                                    }
                                    onClick={
                                        handlePublish
                                    }
                                    style={{
                                        height:
                                            52,
                                        background:
                                            COLORS.black,
                                        borderColor:
                                            COLORS.black,
                                        color:
                                            COLORS.white,
                                        fontWeight:
                                            700
                                    }}
                                >
                                    {
                                        publishing
                                            ? "Publishing..."
                                            : "Publish Test"
                                    }
                                </Button>
                            </Col>
                        </Row>
                    </Card>
                </div>
            </div>
        </>
    );
};

export default Test;


